const fileTypes = {
	xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	xls: 'application/vnd.ms-excel',
};

export { fileTypes };



// WEBPACK FOOTER //
// ./src/common/constants/fileTypeConstants.js